<template>
    <div class="job-detail">
        <siteHeader />
        <div class="job-detail-container">
            <div class="job-detail-card">
                <h2 class="card-title">职位详情 <span class="english-subtitle">Job Details</span></h2>
                <div class="job-detail-content" v-if="jobDetail">
                    <div class="job-header">
                        <h3 class="job-title">{{ jobDetail.position }}</h3>
                        <div class="job-meta">
                            <span class="meta-item">{{ jobDetail.workplace }}</span>
                            <span class="meta-item">{{ jobDetail.numbers }}</span>
                            <span class="meta-item">{{ jobDetail.compensation }}</span>
                            <span class="meta-item">{{ jobDetail.education }}</span>
                            <span class="meta-item">{{ jobDetail.workYears }}</span>
                            <span class="meta-item">{{ jobDetail.department }}</span>
                        </div>
                    </div>
                    <div class="job-description">
                        <h4>职位描述</h4>
                        <div v-html="jobDetail.jobDescriptions || '暂无职位描述'"></div>
                    </div>
                    <div class="job-requirements">
                        <h4>任职要求</h4>
                        <div v-html="jobDetail.jobRequirements || '暂无任职要求'"></div>
                    </div>
                    <div class="contact-info">
                        <h4>联系方式</h4>
                        <p>联系电话：<a href="tel:023-65031293">023-65031293</a></p>
                    </div>
                </div>
                <div v-else class="no-data">
                    <p>暂无职位信息</p>
                </div>
            </div>
        </div>
        <siteFooter />
    </div>
</template>

<script>
import siteHeader from '../components/SiteHeader.vue'
import siteFooter from '../components/SiteFooter.vue'

export default {
    name: 'JobDetailPage',
    components: {
        siteHeader,
        siteFooter
    },
    data() {
        return {
            jobDetail: null
        }
    },
    created() {
        // 从路由参数中获取数据
        const queryData = this.$route.query
        if (queryData.rows && queryData.rows.length > 0) {
            this.jobDetail = queryData.rows[0]
        } else {
            this.jobDetail = queryData
        }
    }
}
</script>

<style scoped>
.job-detail-container {
    max-width: 1200px;
    margin: 20px auto;
    padding: 20px;
}

.job-detail-card {
    background: white;
    border-radius: 12px;
    padding: 32px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.card-title {
    color: #333;
    font-size: 24px;
    margin-bottom: 16px;
    padding-bottom: 8px;
    position: relative;
    display: inline-block;
}

.card-title::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #3c4a6b;
}

.english-subtitle {
    font-size: 20px;
    color: #666;
    font-weight: normal;
}

.job-header {
    margin-bottom: 30px;
}

.job-title {
    font-size: 24px;
    color: #333;
    margin-bottom: 15px;
}

.job-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
}

.meta-item {
    background-color: #f5f5f5;
    padding: 6px 12px;
    border-radius: 4px;
    color: #666;
    font-size: 14px;
}

.job-description,
.job-requirements {
    margin-bottom: 30px;
}

h4 {
    color: #333;
    font-size: 18px;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
}

p {
    color: #666;
    line-height: 1.6;
    margin: 0;
}

.no-data {
    text-align: center;
    padding: 40px;
    color: #999;
}

/* 添加HTML内容的样式 */
:deep(p) {
    margin-bottom: 10px;
    line-height: 1.8;
}

:deep(p:last-child) {
    margin-bottom: 0;
}

.contact-info {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #eee;
}

.contact-info a {
    color: #3c4a6b;
    text-decoration: none;
    font-weight: 500;
}

.contact-info a:hover {
    text-decoration: underline;
}
</style>